module.exports = __webpack_public_path__ + "National2Web-Regular.eot?aa3d4a7adb41beb36dca6fc339121932";